import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../../pages/Home";
import Loading from "../../pages/Loading";
import NotFound from "../../pages/NotFound";

const ConfigRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default ConfigRouter;
